import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import { onFormatLogStatus } from '../../../utils/constants/logs-statuses';
import { tryToFetchSingleActivity } from '../../../store/brokers/partner/agent-activities/agentActivitiesSlice';
import TimeChart from './details/TimeChart';


const LogDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [detailsData, setDetailsData] = useState<any>();
    const details = useAppSelector((state) => state?.agentActivities?.agentActivity);

    const onGoBack = () => {
        navigate(-1)
    }

    useEffect(() => {
        if (details && id) {
            setDetailsData(details)
        }
    }, [details])

    useEffect(() => {
        if (id) {
            dispatch(tryToFetchSingleActivity(id));
        }
    }, [id]);

    const formatString = (str: string): string => {
        return str?.split('_')
            .map(word => word?.charAt(0).toUpperCase() + word?.slice(1))
            .join(' ');
    };

    const startedAt = moment(detailsData?.startedAt);
    const completedAt = moment(detailsData?.completedAt);
    const duration = moment.duration(completedAt.diff(startedAt));

    const totalSeconds = (duration.asMilliseconds() / 1000).toFixed(3);
    const formattedDuration = `${totalSeconds} s`;
    return (
        <div>
            <div className={'flex flex-row items-center justify-between'}>
                <div className='flex flex-row items-center'>
                    <div data-qa={'back-button'} onClick={onGoBack} className='md:-ml-2 xl:-ml-5 md:mr-2 xl:mr-4'>
                        <img src={'/assets/shared/go-back-new.svg'} className={'w-[35px] object-contain cursor-pointer'} />
                    </div>
                    <p className='text-primary-light text-sm font-medium'>AI Logs &gt; Session Information Breakdown</p>
                </div>
            </div>
            <div className='flex flex-row items-center my-4'>
                <p className='text-[19px] font-bold mr-8'>Session Drill-Down</p>
                <p className='text-primary-light text-sm'>ID: {id || detailsData?._id}</p>
            </div>
            <div className='border-y border-y-1 py-3 px-3 flex flex-row items-center my-5'>
                <div className='flex flex-row items-center mr-8'>
                    <p className='text-[#5D6679] font-bold mr-1'>TIMESTAMP:</p>
                    <p className='text-[#5D6679]'>{moment(detailsData?.startedAt)?.format('DD/MM/YYYY, HH:mm')}</p>
                </div>
                <div className='flex flex-row items-center mr-8'>
                    <p className='text-[#5D6679] font-bold mr-1'>End State:</p>
                    <p className='text-[#5D6679]'>{onFormatLogStatus(detailsData?.status)?.name}</p>
                </div>
                <div className='flex flex-row items-center mr-8'>
                    <p className='text-[#5D6679] font-bold mr-1'>Timespan:</p>
                    <p className='text-[#5D6679]'>{formattedDuration}</p>
                </div>
            </div>
            <div className='grid grid-cols-1 lg:grid-cols-2 gap-4'>
                <div className='bg-white p-8 !rounded'>
                    <TimeChart
                        timeInSeconds={Number(totalSeconds || 0)}
                    />
                </div>
                <div className='bg-white p-8 !rounded'>
                    <p className='mb-5 text-[18px]'>Full Log</p>
                    <p className='font-bold mb-2'>Details</p>
                    <div className='flex flex-row items-center my-3'>
                        <p className='text-primary-light mr-4'>Agent:</p>
                        <p className='font-bold'>{formatString(detailsData?.agent)}</p>
                    </div>
                    <div className='flex flex-col md:flex-row items-center'>
                        <div className='flex flex-row items-center my-3 mr-0 md:mr-8'>
                            <p className='text-primary-light mr-4'>Start:</p>
                            <p>{moment(detailsData?.startedAt)?.format('DD/MM/YYYY, HH:mm')}</p>
                        </div>
                        <div className='flex flex-row items-center my-3'>
                            <p className='text-primary-light mr-4'>Duration:</p>
                            <p>{formattedDuration}</p>
                        </div>
                    </div>
                    <div className='flex flex-row items-center my-3'>
                        <p className='text-primary-light mr-4'>Task:</p>
                        <p>{detailsData?.task}</p>
                    </div>
                    {detailsData?.summary &&
                        <div className='my-4'>
                            <p className='text-primary-light mb-3'>Summary:</p>
                            <div className='p-3 bg-[#e5e5e5] !rounded mb-2'>
                                <p>{detailsData?.summary}</p>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default LogDetails;